import React from 'react';

import { GetPakWithPartiesDto } from '../../../common/snrwbCore/autogenerated/snrwbApiClient';
import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { useNavigation } from '../../../common/navigation';
import momencik from '../../../common/momencik';
import OrganizationalUnitBadge from '../OrganizationalUnit/OrganizationalUnitBadge';
import nkitwDesc from '../../../common/nkitwDesc';

import { PakLink } from './PakLink';
import { PakType } from './PakType';

export const pakForGrid = (pak: GetPakWithPartiesDto) => {
  return {
    key: pak.id,
    values: {
      type: <PakType pak={pak} />,
      'organizationalUnit.shortname': (
        <OrganizationalUnitBadge organizationalUnit={pak.organizationalUnit} />
      ),
      startDate: momencik(pak.startDate),
      endDate: momencik(pak.endDate),
      'productType.nkitw': pak.productType ? nkitwDesc(pak.productType) : '',
      parties: pak.parties,
      actNumber: pak.actNumber,
      link: <PakLink pakId={pak.id} />,
    },
    orderByValues: {
      startDate: momencik(pak.startDate, ''),
      endDate: momencik(pak.endDate, ''),
    },
  };
};

export const PakSearch: React.FC<{
  getData: GridGetterFunction;
  getCount: GridCountFunction;
}> = props => {
  const nav = useNavigation();
  const columns = [
    { header: '', property: 'type', noSorting: true },
    { header: 'Organ', property: 'organizationalUnit.shortname' },
    { header: 'Data wszczęcia', property: 'startDate' },
    { header: 'Data zakończenia', property: 'endDate' },
    { header: 'Typ wyrobu', property: 'productType.nkitw' },
    { header: 'Strony', property: 'parties' },
    { header: 'Numer akt', property: 'actNumber' },
    { header: '', property: 'link', className: 'text-center', noSorting: true },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      initialOrderColumn="startDate"
      initialOrderDirection="DESC"
      columns={columns}
      showFilter
      availablePageSizes={[10, 20, 50]}
      onRowClick={nav.pak}
      emptyGridMessage="Brak pasujących postępowań administracyjnych w sprawie nałożenia kary"
      defaultAdditionalFilters={{
        organizationalUnit: '',
        organization: '',
        productType: '',
        startDateFrom: null,
        startDateTo: null,
        endDateFrom: null,
        endDateTo: null,
        fileNumber: '',
      }}
      filterLabels={{ organization: 'Strony' }}
    />
  );
};
